<template>
	<!-- <div v-for="item in data.salesPrice" class="d-flex" v-if="props.salesPrice">
		<input type="checkbox" /><span class="ps-1 pe-3 text-nowrap">{{ item.name }}</span>
	</div>
	<div v-for="item in data.salesType" class="d-flex" v-if="props.salesType">
		<input type="checkbox" /><span class="ps-1 pe-3 text-nowrap">{{ item.name }}</span>
	</div>
    <div v-for="item in data.tourPriceInclude" class="d-flex" v-if="props.tourPriceInclude">
		<input type="checkbox" /><span class="ps-1 pe-3 text-nowrap">{{ item.name }}</span>
	</div> -->
	<div class="flex-grow-1 d-flex align-items-baseline gap-2" v-if="isEdit">
		<div class="me-4 border-end pe-2 text-nowrap" v-if="!(option.length == 1) && canAll ">
			<!-- <button class="btn btn-sm btn-primary" type="button">全選</button> -->
			<div class="form-check mb-0 form-switch">
				<input class="form-check-input" type="checkbox" @change="CkALL()" v-model="data.allStatus"/>
				<label class="form-check-label" :class="{'text-main':data.allStatus, 'text-secondary':!data.allStatus}" role="switch" :for="data.id + `__all`">全選</label>
			</div>
		</div>
		<div class="flex-grow-1 d-flex flex-grow-1 flex-wrap gap-2">
			<div class="my-1 d-flex  flex-wrap" v-for="item,key in option" :key="key">
				<div class="form-check mb-0" :class="{'':option.length > 1 && (key + 1) != option.length ,'form-switch': switchType, 'form-check-reverse': isReverse,'': switchType&&isFill, 'pb-0 flex-grow-1 d-flex': isFill}">
					<label class="form-check-label" :class="{' text-start': isFill}" role="switch" :for="data.id + `__${item.values}`">{{ item.name }}</label>
					<input class="form-check-input" type="checkbox" :id="data.id + `__${item.values}`" :value="item.values" v-model="Pmodel" />
				</div>
			</div>
		</div>
	</div>
	<div v-else>
		<span class="badge fs-6 py-1 bg-main ms-1" v-for="item in getoption">{{ item.name }}</span>
	</div>
</template>
<script setup>
	import _ from "lodash";
	const data = reactive({
		id: "R__" + (Math.random() * 100000).toString().replace(/\./g, "_"),
		salesPrice: "",
		salesTypeY: "",
		tourPriceInclude: "",
		tourPriceExclude: "",
	});
	const CkALL = () => {
		console.log(data.allStatus);
		if(data.allStatus){
			const Tmp = _.cloneDeep(Pmodel.value);
			_.each(props.option, (item, keys) => {
				const index = Tmp.indexOf(item.values);
				if (index == -1) {
					Tmp.push(item.values);
				}
			});
			Pmodel.value = Tmp;
		}else{
			Pmodel.value = []
		}
	};
	const emit = defineEmits(["hottagfunc", "editbtnFunc", "update:model"]);
	const props = defineProps({
		model: {
			type: Array,
			default() {
				return [];
			},
		},
		option: {
			type: Array,
			default() {
				return [];
			},
		},
		isEdit: {
			type: Boolean,
			default: true,
		},
		canAll: {
			type: Boolean,
			default: true,
		},
		switchType: {
			type: Boolean,
			default: true,
		},
		isReverse: {
			type: Boolean,
			default: true,
		},
		isFill: {
			type: Boolean,
			default: false,
		},
	});
	const Pmodel = computed({
		get() {
			return props.model;
		},
		set(data) {
			emit("update:model", data);
		},
	});
	const getoption = computed(() => {
		const Text = _.filter(props.option, (item, keys) => {
			return Pmodel.value.indexOf(item.values) > -1;
		});

		return Text;
	});
</script>
